import { useState, useEffect, useRef } from "react";

const isMobileDevice = () => typeof window !== "undefined" && window.innerWidth <= 768;

export function useMobileFormDraft(storageKey, initialValues, isOpen) {
  const getSavedDraft = () => {
    if (isMobileDevice() && storageKey) {
      const saved = sessionStorage.getItem(`draft_${storageKey}`);
      if (saved) {
        try {
          return JSON.parse(saved);
        } catch (e) {
          console.error("Error reading draft", e);
        }
      }
    }
    return initialValues;
  };

  const [formData, setFormData] = useState(getSavedDraft);
  const isLoadedRef = useRef(false);

  // When popup opens, sync from sessionStorage or fallback to initialValues
  useEffect(() => {
    if (isOpen) {
      const saved = getSavedDraft();
      setFormData(saved);
      isLoadedRef.current = true;
    } else {
      isLoadedRef.current = false;
    }
  }, [isOpen, storageKey]);

  // Sync draft to sessionStorage ONLY when typing while open
  useEffect(() => {
    if (isMobileDevice() && isOpen && storageKey && isLoadedRef.current) {
      sessionStorage.setItem(`draft_${storageKey}`, JSON.stringify(formData));
    }
  }, [formData, isOpen, storageKey]);

  const clearDraft = () => {
    if (isMobileDevice() && storageKey) {
      sessionStorage.removeItem(`draft_${storageKey}`);
    }
    setFormData(initialValues);
  };

  return [formData, setFormData, clearDraft];
}